/**
 * §B-5 — customs enum option lists for the trade-lane editor. Mirrors the
 * worker-side validate.ts (kept out of @cairn/shared, which is frozen). UPPER_SNAKE
 * values so humanizeCode renders them nicely.
 */
export const INCOTERMS = ["DAP", "DDP", "DDU", "EXW", "FCA", "CPT", "CIP"] as const;
export const DUTIES_PAYORS = ["RECEIVER", "SENDER"] as const;
export const IOR_TYPES = ["CUSTOMER", "ENTITY"] as const;
export const VALUE_BASES = ["ORDER_PRICE", "SHOPIFY_COGS", "CUSTOM_PRICE_LIST"] as const;
